import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import partnerService from "../../../services/partners";
import imageUpload from "../../../services/upload";
import {
  FormControl,
  TextField,
  FormHelperText,
  Select,
  MenuItem,
} from "@mui/material";
import { IMAGE_PATH, instanceToken } from "../../../utils/constant";
import partners from "../../../services/partners";
import {
  EditPageLayout,
  EditImageSection,
  EditFieldLabel,
  EditFormTopSection,
} from "../../../components/edit/EditPageLayout";
import { CreateNewPrivilegeSchema } from "../../../schema/CreateNewPrivilegeSchema";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";

const imgFileTypes = ["image/gif", "image/jpeg", "image/png", "image/svg+xml"];

export default function UpdatePrivilege({ homeAlert }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = React.useState("");
  const [imagePreview, setImagePreview] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [imageFileUrl, setImageFileUrl] = useState("");
  const [values, setValues] = useState({ image_url: "" });
  const [nameEng, setNameEng] = useState("");
  const [nameMM, setNameMM] = useState("");
  const [addressEng, setAddressEng] = useState("");
  const [addressMM, setAddressMM] = useState("");
  const [phone, setPhone] = useState("");
  const [promotion, setPromotion] = useState("");

  const [phoneNote, setPhoneNote] = useState("");
  const [link, setLink] = useState("");

  const [errorMessage, setErrorMessage] = useState({});

  const [partner, setPartner] = useState(null);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(CreateNewPrivilegeSchema),
    initialValues: {
      name_en: "",
      name_mm: "",
      address_en: "",
      address_mm: "",
      phone: "",
      phone_note: "",
      category: "",
      link: "",
      promotion: "",
    },
  });

  async function getImageUrl(imgData) {
    const response = await imageUpload.getImageUrl(
      instanceToken.token,
      imgData
    );
    const result = response.data;
    const path = IMAGE_PATH + result?.imageName;
    setImageFileUrl(result?.imageUploadUrl);
    setValues({
      ...values,
      image_url: path,
    });
  }
  useEffect(() => {
    if (!partner) {
      fetchPartner();
    }
  }, []);

  useEffect(() => {
    setNameEng(partner?.name_en);
    setNameMM(partner?.name_mm);
    setAddressEng(partner?.address_en);
    setAddressMM(partner?.address_mm);
    setLink(partner?.link);
    setPhone(partner?.phone);
    setPhoneNote(partner?.phone_note);
    setCategory(partner?.category);
    setPromotion(partner?.promotion);

    if (partner) {
      setValue("name_en", partner?.name_en);
      setValue("name_mm", partner?.name_mm);
      setValue("link", partner?.link);
      setValue("address_en", partner?.address_en);
      setValue("address_mm", partner?.address_mm);
      setValue("phone", partner?.phone);
      setValue("phone_note", partner?.phone_note);
      setValue("category", partner?.category);
      setValue("promotion", partner?.promotion);

      setValues({
        image_url: partner?.image_url || "",
      });
    }
  }, [partner, setValue]);

  const fetchPartner = async () => {
    try {
      const res = await partnerService.getPartner(instanceToken.token, id);
      setPartner(res.data);
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  };

  const changeNameEng = (e) => {
    setNameEng(e.target.value);
  };
  const changeNameMM = (e) => {
    setNameMM(e.target.value);
  };
  const changeAddressEng = (e) => {
    setAddressEng(e.target.value);
  };
  const changeAddressMM = (e) => {
    setAddressMM(e.target.value);
  };
  const changePhone = (e) => {
    setPhone(e.target.value);
  };
  const changePromotion = (e) => {
    setPromotion(e.target.value);
  };
  const changePhoneNote = (e) => {
    setPhoneNote(e.target.value);
  };
  const changeLink = (e) => {
    setLink(e.target.value);
  };

  const changeCategory = (e) => {
    setCategory(e.target.value);
  };

  const changeFile = async (e) => {
    if (e.target.files && e.target.files[0]) {
      if (e.target.files && e.target.files[0]) {
        const img = e.target.files[0];
        if (!imgFileTypes.includes(img.type)) {
          setErrorMessage({
            ...errorMessage,
            image_url: "Please select image. (PNG, JPG, JPEG, GIF, ...)",
          });
          return;
        }
        if (img.size > 204800) {
          setErrorMessage({
            ...errorMessage,
            image_url: "Image file size must be smaller than 200KB.",
          });
          return;
        }
        setImageFile(img);
        setImagePreview(URL.createObjectURL(img));
        getImageUrl(img);
      }
    }
  };

  const formData = new FormData();

  const handleUpdate = async (data) => {
    formData.append("name_en", data?.name_en);
    formData.append("name_mm", data?.name_mm);
    formData.append("address_en", data?.address_en);
    formData.append("address_mm", data?.address_mm);
    formData.append("phone", data?.phone);
    formData.append("phone_note", data?.phone_note);
    formData.append("link", data?.link);
    formData.append("category", data?.category);
    formData.append("promotion", data?.promotion);
    formData.append("image_data", "");
    formData.append(
      "image_url",
      values?.image_url ? values?.image_url : data?.image_url
    );

    try {
      setLoading(true);
      if (imageFile) {
        await imageUpload.uploadImage(imageFileUrl, imageFile);
      }

      const response = await partners.putPartner(
        instanceToken.token,
        id,
        formData
      );
      setPartner(response.data);
      navigate("/privileges");
      homeAlert("New Privilege have been updated.", false);
    } catch (error) {
      console.log(error);
      homeAlert("Error on server.", true);
    } finally {
      setLoading(false);
      setErrorMessage({});
    }
  };

  const handleRemove = async () => {
    try {
      await partnerService.deletePartner(instanceToken.token, id);
      homeAlert("Privilege post have been removed.", false);
      navigate("/privileges");
    } catch (error) {
      console.log(error);
      homeAlert("Error on server!", true);
    }
  };

  return (
    <EditPageLayout
      title="Edit Privilege"
      subtitle="Update privilege details and contact information."
      breadcrumbs={[
        { label: "Privileges", path: "/privileges" },
        { label: `Privilege (ID - ${id})`, path: `/privilege/${id}` },
        { label: "Edit" },
      ]}
      detailPath={`/privilege/${id}`}
      onRemove={handleRemove}
      loading={loading}
      onSubmit={handleSubmit(handleUpdate)}
      removeMessage="Are you sure you want to remove this privilege?"
    >
      <EditFormTopSection
        image={
          <EditImageSection
            uploadLabel="Privilege Image"
            previewLabel="Image Preview"
            imageUrl={values?.image_url}
            imagePreview={imagePreview}
            onFileChange={changeFile}
            error={errorMessage["image_url"]}
            recommendedSize="340 x 180 px (1.8:1)"
          />
        }
      >
        <div>
          <EditFieldLabel required>Name (English)</EditFieldLabel>
          <TextField
            fullWidth
            id="name_en"
            {...register("name_en")}
            onChange={changeNameEng}
            value={nameEng}
            error={!!errors.name_en}
            helperText={errors.name_en?.message}
          />
        </div>
        <div>
          <EditFieldLabel required>Name (Myanmar)</EditFieldLabel>
          <TextField
            fullWidth
            id="name_mm"
            {...register("name_mm")}
            onChange={changeNameMM}
            value={nameMM}
            error={!!errors.name_mm}
            helperText={errors.name_mm?.message}
          />
        </div>
        <div>
          <EditFieldLabel required>Address (English)</EditFieldLabel>
          <TextField
            fullWidth
            id="address_en"
            {...register("address_en")}
            onChange={changeAddressEng}
            value={addressEng}
            error={!!errors.address_en}
            helperText={errors.address_en?.message}
          />
        </div>
        <div>
          <EditFieldLabel required>Address (Myanmar)</EditFieldLabel>
          <TextField
            fullWidth
            id="address_mm"
            {...register("address_mm")}
            onChange={changeAddressMM}
            value={addressMM}
            error={!!errors.address_mm}
            helperText={errors.address_mm?.message}
          />
        </div>
        <div>
          <EditFieldLabel required>Phone</EditFieldLabel>
          <TextField
            fullWidth
            id="phone"
            {...register("phone")}
            onChange={changePhone}
            value={phone}
            error={!!errors.phone}
            helperText={errors.phone?.message}
          />
        </div>
        <div>
          <EditFieldLabel>Phone Note</EditFieldLabel>
          <TextField
            fullWidth
            id="phone_note"
            {...register("phone_note")}
            onChange={changePhoneNote}
            value={phoneNote}
            error={!!errors.phone_note}
            helperText={errors.phone_note?.message}
          />
        </div>
        <div>
          <EditFieldLabel>Link</EditFieldLabel>
          <TextField
            fullWidth
            id="link"
            {...register("link")}
            onChange={changeLink}
            value={link}
            error={!!errors.link}
            helperText={errors.link?.message}
          />
        </div>
        <div>
          <EditFieldLabel required>Category</EditFieldLabel>
          <FormControl fullWidth error={!!errors.category}>
            <Select value={category} onChange={changeCategory} displayEmpty>
              <MenuItem value="" disabled>
                Select category
              </MenuItem>
              <MenuItem value="Hospital">Hospital</MenuItem>
              <MenuItem value="Private-Hospital">Private-Hospital</MenuItem>
              <MenuItem value="Education">Education</MenuItem>
              <MenuItem value="Fitness">Fitness</MenuItem>
              <MenuItem value="Hotel">Hotel</MenuItem>
            </Select>
            <FormHelperText error>
              {errors.category?.message || errorMessage["category"]}
            </FormHelperText>
          </FormControl>
        </div>
        <div>
          <EditFieldLabel>Promotion</EditFieldLabel>
          <TextField
            fullWidth
            id="promotion"
            {...register("promotion")}
            onChange={changePromotion}
            value={promotion}
            error={!!errors.promotion}
            helperText={errors.promotion?.message}
          />
        </div>
      </EditFormTopSection>
    </EditPageLayout>
  );
}
